// src/pages/ServicesPage.js
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import service1 from '../assets/images/logo.png';
import service2 from '../assets/images/logo.png';
import service3 from '../assets/images/logo.png';
import service4 from '../assets/images/logo.png';
import service5 from '../assets/images/logo.png';

const servicesData = [
  {
    image: service1,
    title: 'Temporary Coverage',
    description:
      'Need coverage next week? We match you with pre-vetted CRNAs for short-term assignments — PTO, FMLA, seasonal surges, or last-minute cancellations.',
  },
  {
    image: service2,
    title: 'Long-Term Contracts',
    description:
      'For 3-, 6-, or 12-month assignments, we help you maintain consistency without the overhead of a full-time hire.',
  },
  {
    image: service3,
    title: 'Permanent Placement',
    description:
      'Ready to hire? We introduce you to top CRNA candidates and only charge when you’ve found a great fit — at a flat rate, not a percentage.',
  },
  {
    image: service4,
    title: 'Pre-Screened Talent Pool',
    description:
      'Skip the noise. Get access to CRNAs who are actively seeking new opportunities — including their availability, experience, and preferences.',
  },
  {
    image: service5,
    title: 'Consultation & Coverage Planning',
    description:
      'We begin with a collaborative consultation to assess your team’s gaps and goals. Then we craft a coverage plan tailored to your real needs.',
  },
];

const ServicesPage = () => {
  return (
    <Container className="my-5">
      <h2 className="text-center mb-4" data-aos="fade-up">Our Services</h2>
      <Row>
        {servicesData.map((service, index) => (
          <Col
            md={4}
            key={index}
            className="d-flex align-items-stretch"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <Card className="mb-4 text-center shadow-sm border-0">
              {service.image && (
                <Card.Img
                  variant="top"
                  src={service.image}
                  alt={service.title}
                  style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'contain',
                    margin: '30px auto 0',
                  }}
                />
              )}
              <Card.Body className="px-4">
                <Card.Title className="fw-bold mb-3">{service.title}</Card.Title>
                <Card.Text style={{ fontSize: '0.95rem' }}>{service.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ServicesPage;
